/* eslint-disable */
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

export const ProgramsList = ({ programs }) =>{
  useEffect(() => {
  console.log(" this is programs list  from usereffect");

  programs.forEach((program, index) => {
    console.log(`Program ${index + 1}:`);
    for (const prop in program) {
      console.log(`${prop}:`, program[prop]);
    }
  });
}, []);

  
 
  return <ul className="related-programs-list-container">
     {programs.map((program) => (
       <>
         <div className="dashboard-related-program-item">
           <img src={program?.bannerImgSrc} alt="related programs image" className='r4c-related-programs-item-img' />
           <div className="r4c-related-programs-list-item-wrapper">
             <li key={program.programUrl} className="my-2 r4c-related-programs-list-item">
               {program.title}
             </li>
             <a href={program.programUrl} className='r4c-related-programs-list-link'>View micro-programme</a>
           </div>
         </div>
 
       </>
     ))}
   </ul>
 
} 

ProgramsList.propTypes = {
  programs: PropTypes.arrayOf(
    PropTypes.shape({
      programUrl: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default ProgramsList;
